import { VehicletypeEnum } from "packages/libs/shared-models/src/Enum/vehicle-type.enum";
import { VehicleTypeEnum } from "./vehicle.enum";

export class VehicleTypeReq {
    vehicleType: string;
    categoryId:number
    vendorId?:number
    vehiclesType?:VehicletypeEnum
    vendorCode?:string
    plant?:string
    
    constructor(vehicleType: string,categoryId:number,vendorId?:number,vehiclesType?:VehicletypeEnum,vendorCode?:string, plant?:string){
        this.vehicleType= vehicleType;
        this.categoryId= categoryId;
        this.vendorId= vendorId;
        this.vehiclesType= vehiclesType;
        this.vendorCode= vendorCode;
        this.plant=plant
        }
}